import FeatureGates from '@atlaskit/feature-gate-js-client';
import { addFeatureFlagAccessed } from '../feature-flags-accessed';

// copied from '@atlaskit/tmp-editor-statsig/expVal' to avoid circular dependency
export var expVal = function expVal(experimentName, experimentParam, defaultValue) {
  // If client is not initialized, we return the default value
  if (!FeatureGates.initializeCompleted()) {
    return defaultValue;
  }

  // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
  var experimentValue = FeatureGates.getExperimentValue(experimentName, experimentParam, defaultValue);
  addFeatureFlagAccessed("".concat(experimentName, ":").concat(experimentParam), experimentValue);
  return experimentValue;
};